var React = require('react');

function LongArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M124 351.93V56a24 24 0 0 1 24-24h24a24 24 0 0 1 24 24v295.93l-36 35.67z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M313 337.46L177.48 473l-.06.06a25.23 25.23 0 0 1-34.84 0l-.06-.06L7 337.46a24 24 0 0 1 0-33.94l17-17a24 24 0 0 1 33.94 0L160 387.6l102-101.08a24 24 0 0 1 33.94 0l17 17a24 24 0 0 1 .06 33.94z","className":"fa-primary","key":2})]);
}

LongArrowDown.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = LongArrowDown;

LongArrowDown.default = LongArrowDown;
